document.addEventListener('DOMContentLoaded', function () {
    initColorSwatches();
    smHeroInitCarousel();
    initOwlSliders();
    trackRecentlyViewed();
    renderRecentlyViewed();
    initRelatedProductsSlider();
});
 
function smHeroInitCarousel() {
var $slider = jQuery('.sm-hero-slider');

if (!$slider.length) return;

// Extract settings from data attributes
var desktopItems  = parseInt($slider.data('desktop-items'))  || 3;
var mobileItems   = parseFloat($slider.data('mobile-items')) || 1.5;
var autoplay      = $slider.data('autoplay') === true;
var loop          = $slider.data('loop') === true;
var autoplaySpeed = parseInt($slider.data('autoplay-speed')) || 4000;
var nav           = $slider.data('nav') === true;
var dots          = $slider.data('dots') !== false;
var margin        = parseInt($slider.data('margin')) || 0;

$slider.owlCarousel({
    loop: loop,
    autoplay: autoplay,
    autoplayTimeout: autoplaySpeed,
    autoplayHoverPause: true,
    nav: nav,
    dots: dots,
    margin: margin,
    navText: [

            '<span class="owl-prev-icon"> </span>',
            '<span class="owl-next-icon"> </span>'   
    ],
    responsive: {
    0: {
        items: mobileItems,
         
    },
    768: {
        items: mobileItems
    },
    1024: {
        items: desktopItems
    }
    }
});
}
 
/**
 * Initialize all Owl Carousel sliders with .sm-owl-product-slider class
 */
function initOwlSliders() {
    const sliders = document.querySelectorAll('.sm-owl-product-slider');

    if (sliders.length === 0) return;

    // Check if jQuery and OwlCarousel are available
    if (typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) {
        console.warn('Owl Carousel requires jQuery and OwlCarousel plugin to be loaded in your Shopify theme.');
        return;
    }

    sliders.forEach(function (slider) {
        const $slider = jQuery(slider);

        // Extract settings from data attributes
        const desktopItems = parseInt($slider.data('desktop-items')) || 3;
        const mobileItems = parseFloat($slider.data('mobile-items')) || 1.5;
        const autoplay = $slider.data('autoplay') === true;
        const loop = $slider.data('loop') === true;

        $slider.owlCarousel({
            loop: loop,
            margin: 15,
            nav: true,
            dots: false,
            autoplay: autoplay,
            autoplayTimeout: 5000,
            navText: [
                '<span class="owl-prev-icon"> </span>',
                '<span class="owl-next-icon"> </span>'
            ],
            responsive: {
                0: {
                    items: mobileItems,
                    margin: 8,
                    nav: true
                },
                768: {
                    items: desktopItems,
                    nav: true
                }
            }
        });
    });
}

/**
 * Re-initialize sliders when Shopify Theme Editor changes occur
 */
document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.sm-owl-product-slider')) {
        initOwlSliders();
    }
    if (event.target.querySelector('.sm-recently-viewed-trigger')) {
        renderRecentlyViewed();
    }
    if (event.target.querySelector('.sm-swatch')) {
        initColorSwatches();
    }
});

/**
 * Initialize Color Swatches image swap logic
 */ 
function initColorSwatches() {
    const cards = document.querySelectorAll('.sm-product-card');

    cards.forEach(function (card) {
        const nameLocation = card.querySelector('.sm-product-swatche-color');
        const activeSwatch = card.querySelector('.sm-swatch.active');
 
        if (activeSwatch && nameLocation) {
            const activeName = activeSwatch.getAttribute('title'); 
            if (activeName) {
                nameLocation.textContent = activeName;
            }
        }
 
        const swatches = card.querySelectorAll('.sm-swatch');

        swatches.forEach(function (swatch) {
            swatch.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const targetImageSelector = this.parentElement.dataset.mainImageSelector || '.sm-product-image';
                const targetImage = card.querySelector(targetImageSelector);
                const newImageSrc = this.dataset.variantImage;
                const selectedName = this.getAttribute('title');

                if (targetImage && newImageSrc && newImageSrc !== 'null' && newImageSrc !== '') {
                    swatches.forEach(s => s.classList.remove('active'));
                    this.classList.add('active');

                    targetImage.src = newImageSrc;
                    if (targetImage.srcset) {
                        targetImage.srcset = newImageSrc;
                    }
                }

                if (nameLocation && selectedName) {
                    nameLocation.textContent = selectedName;
                }
            });
        });
    });
}
/**
 * Track recently viewed product handles in localStorage
 */
function trackRecentlyViewed() {
    // Only track on product pages
    if (!document.body.classList.contains('template-product')) {
        const productTemplateCheck = document.querySelector('.product-template, main.product, section.product');
        if (!productTemplateCheck && !window.location.pathname.includes('/products/')) return;
    }

    // Get handle from body attribute (added by user in theme.liquid)
    let currentHandle = document.body.dataset.smProductHandle;

    // Fallback if body attribute isn't found
    if (!currentHandle && window.location.pathname.includes('/products/')) {
        currentHandle = window.location.pathname.split('/').pop().split('?')[0];
    }

    if (!currentHandle) return;

    let recentViewed = JSON.parse(localStorage.getItem('sm_recently_viewed')) || [];

    // Remove if already exists to move it to the front
    recentViewed = recentViewed.filter(handle => handle !== currentHandle);

    // Add to front
    recentViewed.unshift(currentHandle);

    // Limit to 20
    if (recentViewed.length > 20) {
        recentViewed = recentViewed.slice(0, 20);
    }

    localStorage.setItem('sm_recently_viewed', JSON.stringify(recentViewed));
}

/**
 * Render recently viewed products from localStorage
 */
async function renderRecentlyViewed() {
    const trigger = document.querySelector('.sm-recently-viewed-trigger');
    if (!trigger) return;

    const container = trigger.querySelector('.sm-recently-viewed-container');
    if (!container) return;

    // Use current handle to exclude it from the list
    const currentHandle = document.body.dataset.smProductHandle || trigger.dataset.currentProduct;

    const desktopItems = parseInt(trigger.dataset.desktopItems) || 4;
    const mobileItems = parseFloat(trigger.dataset.mobileItems) || 1.5;
    const limit = parseInt(trigger.dataset.limit) || 10;

    let recentViewed = JSON.parse(localStorage.getItem('sm_recently_viewed')) || [];

    // Filter out current product
    recentViewed = recentViewed.filter(handle => handle !== currentHandle);

    if (recentViewed.length === 0) {
        trigger.style.display = 'none';
        return;
    }

    // Limit based on section settings
    recentViewed = recentViewed.slice(0, limit);

    // Show section
    trigger.style.display = 'block';

    // Fetch product data and build HTML
    const productPromises = recentViewed.map(handle =>
        fetch(`/products/${handle}.js`).then(res => res.json()).catch(() => null)
    );

    const products = (await Promise.all(productPromises)).filter(p => p !== null);

    if (products.length === 0) {
        trigger.style.display = 'none';
        return;
    }

    let itemsHtml = '';
    products.forEach(product => {
        const price = Shopify.formatMoney ? Shopify.formatMoney(product.price, "{{ shop.money_format }}") : (product.price / 100).toFixed(2);
        let featuredImage = ''; 
        if(product.media[1].src != ''){ 
             featuredImage = product.media[1].src || '';
        }else{ 
             featuredImage = product.featured_image || '';
        }
 
        // Handle color swatches for dynamic rendering
        let swatchesHtml = '';
        let colorOption = product.options.find(opt => opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour');
        if (colorOption) {
            swatchesHtml = `<div class="sm-product-swatches" data-main-image-selector=".sm-product-image">`;
            const shownColors = [];
            product.variants.forEach(variant => {
                const colorValue = variant.options[colorOption.position - 1];
                if (variant.featured_image && !shownColors.includes(colorValue)) {
                    const activeClass = product.variants[0].id === variant.id ? 'active' : '';
                    swatchesHtml += `
                        <div class="sm-swatch ${activeClass}" 
                             style="background-color: ${colorValue.split(' ').pop().toLowerCase()};"
                             data-variant-image="${variant.featured_image.src}"
                             data-variant-id="${variant.id}"
                             title="${colorValue}">
                        </div>
                    `;
                    shownColors.push(colorValue);
                }
            });
            swatchesHtml += `</div>`;
        }
        // ${swatchesHtml}
        itemsHtml += `
            <div class="item">
                <div class="sm-product-card" data-handle="${product.handle}">
                    <a href="${product.url}" class="sm-product-link">
                        <div class="sm-product-image-wrapper">
                            ${featuredImage ? `<img src="${featuredImage}" alt="${product.title}" class="sm-product-image" loading="lazy">` : `<div class="placeholder-svg"></div>`}
                        </div>
                    </a>
                    <div class="sm-product-info" style="display: none; ">
                        <a href="${product.url}" style="text-decoration: none; color: inherit;">
                            <p class="sm-product-name">${product.title}</p>
                        </a>
                      
                    </div>
                </div>
                  <div class="sm-product-swatche-color"></div> 
            </div>
        `;
    });

    // Inject HTML
    container.innerHTML = itemsHtml;

    // Initialize Swatches for dynamic content
    initColorSwatches();

    // Initialize Owl Carousel
    if (typeof jQuery !== 'undefined' && jQuery.fn.owlCarousel) {
        jQuery(container).owlCarousel({
            loop: false,
            margin: 15,
            nav: true,
            dots: false,
            navText: [
                '<span class="owl-prev-icon"></span>',
                '<span class="owl-next-icon"></span>'
            ],
            responsive: {
                0: {
                    items: mobileItems,
                    margin: 8,
                    nav: true
                },
                768: {
                    items: desktopItems,
                    nav: true
                }
            }
        });
    }
}



/**
 * Initialize Related Products Slider
 * Polls until .related-products has .product-recommendations--loaded,
 * then wraps .product-grid children in an Owl Carousel if more than 1 child exists.
 */
function initRelatedProductsSlider() {
    const relatedSection = document.querySelector('.related-products');
    if (!relatedSection) return;

    const desktopItems = 4;
    const mobileItems = 2;
    const loop = false;
    const autoplay = false;

    const intervalId = setInterval(function () {
        if (!relatedSection.classList.contains('product-recommendations--loaded')) return;

        clearInterval(intervalId);

        const productGrid = relatedSection.querySelector('.product-grid');
        if (!productGrid) return;

        const children = productGrid.children;
        if (children.length <= 1) return;

        if (typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) {
            console.warn('Owl Carousel requires jQuery and OwlCarousel plugin.');
            return;
        }
        productGrid.classList.add('owl-carousel');
        // Wrap each child in an .item div as Owl Carousel expects
        Array.from(children).forEach(function (child) {
            if (!child.classList.contains('item')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'item';
                productGrid.insertBefore(wrapper, child);
                wrapper.appendChild(child);
            }
        });

        jQuery(productGrid).owlCarousel({
            loop: loop,
            margin: 15,
            nav: true,
            dots: false,
            autoplay: autoplay,
            autoplayTimeout: 5000,
            navText: [
                '<span class="owl-prev-icon"> </span>',
                '<span class="owl-next-icon"> </span>'
            ],
            responsive: {
                0: {
                    items: mobileItems,
                    margin: 8,
                    nav: true
                },
                768: {
                    items: desktopItems,
                    nav: true
                }
            }
        });

    }, 300);
}

$(document).ready(function(){
    $('.nav_close_area .header_menu_close').click(function(){ 
     $('.header__icon--menu').trigger('click');
    }); 
}); 